import { DBSessionThunks, SessionReducerActions, sessionSelectors } from '@common/reducers/DBServiceThunks';

/**
 * Ids present in the store but absent from a complete server listing — i.e. sessions the server
 * removed. Returns [] when the listing is not known to be complete (fetch failed, or a paginated
 * page that doesn't cover the total), so we never prune on partial data.
 */
export function staleSessionIds(
  storeIds: readonly string[],
  fetched: ReadonlyArray<{ _id?: string }> | undefined | null,
  total?: number,
): string[] {
  if (!Array.isArray(fetched)) return [];
  if (typeof total === 'number' && total > fetched.length) return [];
  const live = new Set(fetched.map((s) => s._id));
  return storeIds.filter((id) => !live.has(id));
}

/**
 * Refetch the user's sessions AND drop the ones the server no longer has.
 *
 * `DBSessionThunks.find` only upserts — it cannot remove an entity missing from the result. So a
 * never-scanned gateway the backend reaped (QR attempts exhausted → deployment + session removed)
 * lived on in the store as `qrcode` with its last, long-expired QR, and the connect dialog kept
 * showing that dead code with no hint anything was wrong.
 */
export const refreshSessions = () => async (dispatch: any, getState: () => any) => {
  const result = await dispatch(DBSessionThunks.find({}));
  const total = getState().DBSessionReducer?.total;
  const stale = staleSessionIds(sessionSelectors.selectIds(getState()) as string[], result?.payload, total);
  if (stale.length) dispatch(SessionReducerActions.removeMany(stale));
};
